export interface IUserBalance {
  balanceCurrCode: string
  balanceCurrId: string | number
  balanceAmountAvailable: number | string
  balanceAmountHeld: number | string
  balanceAmountTotal: number | string
  btcBalance: number | string
  lastTrade: number | string | Date
  balanceQuoteCurrCode: string
  lastPrice: number | string
  balanceCurrName: string
  balanceCurrSlug: string
  balanceCurrImgName: string
}

export class UserBalance implements IUserBalance {
  constructor(
    public balanceCurrCode: string = '',
    public balanceCurrId: string | number = '',
    public balanceAmountAvailable: number | string = '',
    public balanceAmountHeld: number | string = '',
    public balanceAmountTotal: number | string = '',
    public btcBalance: number | string = '',
    public lastTrade: number | string | Date = '',
    public balanceQuoteCurrCode: string = '',
    public lastPrice: number | string = '',
    public balanceCurrName: string = '',
    public balanceCurrSlug: string = '',
    public balanceCurrImgName: string = ''
  ) {}
}

export default UserBalance 